<template>
	<div class="text-sm">
		<button v-if="!isSubscribed" @click.prevent="subscribe"
				class="btn btn-default btn-md flex justify-start items-center space-x-2"
				title="Подписаться">
			<svg-icon icon="person-plus-fill" class="w-5 h-5"></svg-icon>
			<span>Подписаться</span>
		</button>

		<div class="relative" v-click-outside="closeModal">
			<button v-if="isSubscribed" @click="toggleModal" class="btn btn-md btn-default">
				<span class="w-full flex justify-start items-center space-x-2">
					<svg-icon v-if="isNotify" icon="bell-fill" class="w-4 h-4 text-orange shrink-0"></svg-icon>
					<svg-icon v-else icon="check-lg" class="w-4 h-4 text-green-500"></svg-icon>
					<span>Вы подписаны</span>
					<svg-icon icon="chevron-down" class="w-4 h-4 text-gray-500 dark:text-slate-400"></svg-icon>
				</span>
			</button>
			<div v-if="modal"
				 class="absolute shadow-lg translate-y-2 border border-gray-100 flex flex-col left-0 top-full w-52 rounded p-2
				 bg-white dark:bg-slate-700 dark:text-white dark:border-slate-600 space-y-0.5">
				<div
					@click.prevent="notifyChange(!isNotify)"
					class="p-1.5 rounded w-full hover:bg-gray-100/20 cursor-pointer flex justify-start items-center space-x-2">
					<svg-icon v-if="isNotify" icon="check-square-fill" class="w-4 h-4 shrink-0"></svg-icon>
					<svg-icon v-else icon="square" class="w-4 h-4 shrink-0"></svg-icon>
					<span>Уведомлять о постах</span>
				</div>
				<div
					@click.prevent="unsubscribe"
					class="p-1.5 rounded w-full hover:bg-gray-100/20 cursor-pointer flex justify-start items-center space-x-2">
					<svg-icon icon="person-dash-fill" class="w-4 h-4 shrink-0 dark:text-slate-300"></svg-icon>
					<span>Описаться</span>
				</div>
			</div>
		</div>
	</div>
</template>
<script>
import Client from "../../js/modules/Client";
import {notify} from "@kyvg/vue3-notification";

export default {
	props: [
		'subscribed',
		'notify',
		'type',
		'id',
		'compact',
	],
	data() {
		return {
			isSubscribed: this.subscribed || false,
			isNotify: this.notify || false,
			modal: false,
		};
	},
	methods: {
		closeModal() {
			this.modal = false;
		},
		toggleModal() {
			this.modal = !this.modal;
		},
		subscribe() {
			this.isSubscribed = true;

			notify({
				type: 'success',
				text: 'Вы подписаны',
			})

			Client.post(this.getUrl())
				.then(response => {
					this.isSubscribed = response.data.is_subscribed;
					this.isNotify = response.data.is_subscribed_with_notifications;
				})
				.catch(error => {
					notify({
						type: 'error',
						text: 'Что-то пошло не так',
					});
				});
		},
		unsubscribe() {
			this.isSubscribed = false;
			this.isNotify = false;
			this.modal = false;

			notify({
				type: 'success',
				text: 'Вы отписаны',
			})

			Client.delete(this.getUrl())
				.catch(error => {
					notify({
						type: 'error',
						text: 'Что-то пошло не так',
					});
				});
		},
		notifyChange(enabled) {
			this.isNotify = enabled;

			notify({
				type: 'success',
				text: this.isNotify ? 'Теперь вы будете получать уведомления о новых постах' : 'Уведомления о новых постах отключены'
			})

			Client.patch(this.getUrl(), {notify: enabled})
				.catch(error => {
					notify({
						type: 'error',
						text: 'Что-то пошло не так',
					});
				});
		},
		getUrl() {
			return '/api/v1.1/' + this.type + '/' + this.id + '/subscribe';
		}
	}
}
</script>
